<template>
  <div class="page-maindiv">
    <!-- Main -->
    <div class="area-main">
      <!-- Area titolo -->
      <div class="area-top">
        <div class="area-top-title">
          {{ $t('archivi') }}
        </div>
      </div>
      <div class="area-description" v-if="!loading">
        <div v-html="pageDescription" v-if="!loading"></div>
        <b-button id="button-more" pill variant="info" class="p-1 mb-4 button-color" v-if="pageDescriptionMore != ''" v-b-toggle.collapse-more >{{ $t(buttonMoreTranslationKey) }}</b-button>
        <b-collapse id="collapse-more" class="mt-2" @shown="buttonMoreTranslationKey = 'readless'" @hidden="buttonMoreTranslationKey = 'readmore'">
          <p class="card-text text-left" v-html="pageDescriptionMore"></p>
        </b-collapse>
      </div>
      <!-- Area ricerca -->
      <div class="area-search" v-if="!loading">
        <b-icon :icon="(this.sort === 1) ? 'sort-alpha-down' : 'sort-alpha-down-alt'" aria-label="sort" style="margin-right: 15px; cursor: pointer" class="h2 pt-2" @click="setSort()"></b-icon>
        <b-input-group>
          <b-input-group-prepend style="height: 40px" is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input v-model="searchFilter.searchStructures" style="height: 40px" type="search" :placeholder="$t('filtro_semplice')"></b-form-input>
        </b-input-group>
      </div>
      <!-- Area cards -->
      <div class="results-cards" >
        <div class="spinner-div"><b-spinner class="spinner" label="Busy" v-if="loading"></b-spinner></div>
        <b-card
            class="results-card"
            no-body
            border-variant="white"
            v-for="(structure, index) in filteredStructures"
            :key="structure.id"
            @mouseover="hoverCard(index)"
            @mouseout="hoverCard(-1)"
        >
          <b-link :to="{name: 'collections', params: {idStructure: structure.id, previousPageLink: '/archives', previousPageTitle: $t('archivi')}}">
            <b-card-img-lazy class="results-card-image" :class="{'selected': isSelected(index)}" :src="structure.immagine" :alt="structure.nome" top></b-card-img-lazy>
            <b-card-text class="results-card-num-results" style="margin-left: 15px">
              <p class="mb-0">{{ structure.num_collezioni + " " + $tc("collezioni-n", structure.num_collezioni) }}</p>
              <div style="display: flex">
                <p class="mb-0">{{ structure.num_immagini }}<b-icon class="ml-1 mr-3" icon="image"></b-icon></p>
<!--                <p class="mb-0">{{ structure.num_audio }}<b-icon class="ml-1 mr-3" icon="headphones"></b-icon></p>-->
                <p class="mb-0">{{ structure.num_video }}<b-icon class="ml-1" icon="camera-reels"></b-icon></p>
<!--                <p class="mb-0">{{ structure.num_altro }}<b-icon class="ml-1" icon="box"></b-icon></p>-->
              </div>
            </b-card-text>
            <b-card-text class="results-card-title" style="margin-left: 15px;">
              {{ structure.nome }}
            </b-card-text>
          </b-link>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Structures',
  data: function() {
    return {
      buttonMoreTranslationKey: "readmore",
      pageDescriptionRecord: "",
      searchFilter: {
        searchStructures: '',
        area: '',
      },
      structures: [],
      selectedCard: -1,
      sort: 1, // 1: AZ, -1: ZA
      loading: true,
    };
  },
  created() {
    this.fetchStructures()
  },
  computed: {
    pageDescription() {
      let desc = "";
      if (this.pageDescriptionRecord != null)
        for (let trad in this.pageDescriptionRecord["traduzioni"]) {
          if (this.pageDescriptionRecord["traduzioni"][trad]["lingua"].startsWith("it"))
            desc = this.pageDescriptionRecord["traduzioni"][trad].contenuto;
          if (this.pageDescriptionRecord["traduzioni"][trad]["lingua"].startsWith(this.$i18n.locale))
            desc = this.pageDescriptionRecord["traduzioni"][trad].contenuto;
        }
      return desc;
    },
    pageDescriptionMore() {
      let desc = "";
      if (this.pageDescriptionRecord != null)
        for (let trad in this.pageDescriptionRecord["traduzioni"]) {
          if (this.pageDescriptionRecord["traduzioni"][trad]["lingua"].startsWith("it"))
            desc = this.pageDescriptionRecord["traduzioni"][trad].contenuto2;
          if (this.pageDescriptionRecord["traduzioni"][trad]["lingua"].startsWith(this.$i18n.locale))
            desc = this.pageDescriptionRecord["traduzioni"][trad].contenuto2;
        }
      return desc;
    },
    filteredStructures() {
      const structures = this.structures;
      for (let structure in structures) {
        // Compila nome e descrizione
        structures[structure].nome = "";
        structures[structure].descrizione = "";
        for (let trad in structures[structure]["traduzioni"]) {
          if (structures[structure]["traduzioni"][trad]["lingua"].startsWith("it")) {
            structures[structure].nome = structures[structure]["traduzioni"][trad].nome;
            structures[structure].descrizione = structures[structure]["traduzioni"][trad].descrizione;
          }
          if (structures[structure]["traduzioni"][trad]["lingua"].startsWith(this.$i18n.locale)) {
            structures[structure].nome = structures[structure]["traduzioni"][trad].nome;
            structures[structure].descrizione = structures[structure]["traduzioni"][trad].descrizione;
          }
        }
      }
      let result = structures;
      // Presenza di filtro su area
      if (!this.$utilities.isEmpty(this.searchFilter.area))
        result = result.filter(structure => {
          return structure.colore_area.toLowerCase() == this.searchFilter.area.toLowerCase();
        });
      // Presenza di filtro testuale
      if (!this.$utilities.isEmpty(this.searchFilter.searchStructures))
        result = result.filter(structure => {
          return structure.nome.toLowerCase().includes(this.searchFilter.searchStructures.toLowerCase());
        });
      // Sort
      return result.sort((a, b) => {
        if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
          return this.sort;
        } else if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
          return -this.sort;
        } else
          return 0;
      })
    },
  },
  methods: {
    async fetchStructures() {
      const pageDescriptionData = await this.$client.getItems("pagine", {
        fields: ["*", "traduzioni.*"],
        filter: {
          nome: {
            eq: 'archivi_biblioteche'
          }
        }
      });
      if (pageDescriptionData.data !== null && pageDescriptionData.data.length > 0)
        this.pageDescriptionRecord = pageDescriptionData.data[0];

      const defaultImageUrl = await this.$client.getAssetUrl("cl4ladr0lo8w4ck0", {key: "directus-large-contain"});

      const structuresData = await this.$client.getItems("dipartimenti", {fields: ["*", "traduzioni.*"], filter: {
          tipologia: {
            eq: 'biblioteca'
          }
        }});
      let structures = structuresData.data;
      for (let structure in structures) {
        structures[structure].nCollections = 0;
        structures[structure].nome = "";
        if (structures[structure].immagine !== null) {
          const imageId = "" + structures[structure].immagine.id;
          const fileData = await this.$client.getFile(imageId);
          structures[structure].immagine = fileData;
          let file = fileData.data;
          const assetUrl = await this.$client.getAssetUrl(file.private_hash, {key: "directus-large-contain"});
          structures[structure].immagine = assetUrl;
        } else {
          structures[structure].immagine = defaultImageUrl;
        }
        for (let trad in structures[structure]["traduzioni"]) {
          if (structures[structure]["traduzioni"][trad]["lingua"].startsWith("it")) {
            structures[structure].nome = structures[structure]["traduzioni"][trad].nome;
            structures[structure].descrizione = structures[structure]["traduzioni"][trad].descrizione;
          }
          if (structures[structure]["traduzioni"][trad]["lingua"].startsWith(this.$i18n.locale)) {
            structures[structure].nome = structures[structure]["traduzioni"][trad].nome;
            structures[structure].descrizione = structures[structure]["traduzioni"][trad].descrizione;
          }
        }
      }
      this.structures = structures.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
      this.loading = false;
    },
    hoverCard(selectedIndex) {
      this.selectedCard = selectedIndex
    },
    isSelected (cardIndex) {
      return this.selectedCard === cardIndex
    },
    setSort() {
      this.sort = (this.sort === 1) ? -1 : 1;
    },
  }
}
</script>

<style>
</style>